import router from "@/views/page";
import fullrouter from "@/views/fullpage";
var routerArr=[]

routerArr=router.concat(fullrouter)
export default routerArr